/**
 * The web's home for the editors' per-machine preferences (editor-core's
 * `FloorPlanPreferences` and its store): one object under one localStorage
 * key, shared live by every editor on the page. Another tab's change is
 * adopted too. Importing this module keeps the preferences in localStorage.
 */
import { setFloorPlanPreferencesStorage } from '@kaiizen/kai-floor-plan-editor-core';

export const FLOOR_PLAN_PREFERENCES_KEY = 'kai.floorPlanPreferences';

setFloorPlanPreferencesStorage({
  read: () => globalThis.localStorage?.getItem(FLOOR_PLAN_PREFERENCES_KEY) ?? null,
  write: serialized => globalThis.localStorage?.setItem(FLOOR_PLAN_PREFERENCES_KEY, serialized),
  listen: onExternalChange =>
    globalThis.window?.addEventListener('storage', event => {
      if (event.key === FLOOR_PLAN_PREFERENCES_KEY) onExternalChange(event.newValue);
    }),
});
